import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import ProductInfo from '../ProductInfo';
import ProductInfoUnderOrder from './ProductInfoUnderOrder';
import ProductStatus from './ProductStatus';
import IconEnabled from 'core/components/layout/IconEnabled';


export default function ProductListTableRow({obj, getActionComponent,actionList, handleRowClick}){
  const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard)
  const {productObj} = useSelector((state)=>state.pharmaslice.productDashboard)
  const {rolename} = useSelector((state)=>state.headerslice.userprofileInfo)
  useEffect(()=>{
  },[productObj])
  
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%', }}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
            sx={{cursor: 'pointer',
              backgroundColor:obj.expand?'primary.200':'',
              justifyContent: "flex-start", alignItems: "center",  padding:1,  
              '&:hover': {
                backgroundColor: 'secondary.lighter', color: 'primary.main'
              },
            }}>
            {/* <ROW1 - CELLS/> */}
            {pharmaorderObj.id===undefined?<Grid item lg={1} md={1} sm={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.orderid}</Typography></Grid>:<></>}
              <Grid item lg={1} md={1} sm={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.id}</Typography></Grid>
              <Grid item lg={3} md={3} sm={3} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.brandname}</Typography></Grid>
              <Grid item lg={3} md={3} sm={3} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.designstatus}</Typography></Grid>
              <Grid item lg={2} md={2} sm={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.designstatusqa}</Typography></Grid>
              {/* <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.formname}</Typography></Grid>
    
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.amount}</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.statusname}</Typography></Grid>
              {pharmaorderObj.id===undefined?
                <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.rmstatus}</Typography></Grid>
              :<></>} */}
              
              
              
              <Grid item lg={2} md={2} xs={2} >
                <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                  {getActionComponent(obj)}
                  {rolename==='PHARMA_OMS_ADMIN' && (obj.orderstatus!=='Draft' && obj.orderstatus!=='REFERRED BACK') && 
                                      <IconEnabled key={`${obj.id}-${actionList[2].title}`} actionObj={actionList[2]} id={obj.id} />
                                    }
                </Grid>
              </Grid>
            
          </Grid>
        </Grid>
        {obj.expand ?
        <Grid container direction="row" sx={{backgroundColor:'#fafafa'}}>
          <Grid item sx={{ width: '100%', paddingBottom:1}}>
            < ProductInfoUnderOrder  productObj={obj} />
          </Grid>
          {/* <Grid item sx={{ width: '100%', paddingBottom:1}}>
            < ProductStatus productObj={obj}/>
          </Grid> */}
          <Grid item sx={{ width: '100%', paddingBottom:.15, backgroundColor:'primary.200'}}>
            {/* <Divider sx={{backgroundColor:'primary.200'}} /> */}
          </Grid>
        </Grid>
        : <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>}
      </>
      
    )
}